module.exports = __webpack_public_path__ + "img/GT.4f9b9a55.png";